export default "__VITE_ASSET__gO613DTi__"